// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gK_I","tabsBox":"styles_tabsBox__3B4x8","createButton":"styles_createButton__3cQ0m"};